import { render, staticRenderFns } from "./ErgebnisColorAndValueNoChart.vue?vue&type=template&id=6118834c&scoped=true"
import script from "./ErgebnisColorAndValueNoChart.vue?vue&type=script&lang=js"
export * from "./ErgebnisColorAndValueNoChart.vue?vue&type=script&lang=js"
import style0 from "./ErgebnisColorAndValueNoChart.vue?vue&type=style&index=0&id=6118834c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6118834c",
  null
  
)

export default component.exports